import { CommonConstants } from './../utilities/commonConstants';
import { Injectable } from '@angular/core';
import { RouteContextProvider } from '../services/routeContextProvider.service';
import { Formatter } from './../services/formatter';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from './sharedService';
import { SessionHandlerService } from '../../../app/common/services/sessionHandler.service';
import { ClevertapEventHandlerService } from '../../../app/shared/services/cleverTapHandler.service';


const TaskKeyArray = {
  productlisting: CommonConstants.Routes.ApplicationModule.PlanDetail,
  getgoingnow: CommonConstants.Routes.Application.GetGoingNow,
  proposerdetails: CommonConstants.Routes.DetailsModule.ProposerPersonalDetails,
  insurerdetails: CommonConstants.Routes.InsuredModule.InsurerDetails,
  productsummarydetail: CommonConstants.Routes.FinalModule.ProductReview,
  quotecriteria: CommonConstants.Routes.Application.GetGoingNowEdit,
  hrevampproposerdetails: CommonConstants.Routes.DetailsModule.ProposerPersonalDetails,
  permanentaddressdetails: CommonConstants.Routes.QuestionnaireModule.MoreAboutYou,
  nomineedetails: CommonConstants.Routes.QuestionnaireModule.MoreAboutYou,
  questionnairedetails: CommonConstants.Routes.QuestionnaireModule.MoreAboutYou,
  hrshowapplicationlist: CommonConstants.Routes.ApplicationList,
  insspousedetailspage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  hrfatherdetailspage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  hrmotherdetailspage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  inschild1detailspage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  inschild2detailspage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  inschild3detailspage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  inschild4detailspage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  insfatherdetailspage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  insmotherdetailspage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  insfatherinlawpage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  insmotherinlawpage: CommonConstants.Routes.InsuredModule.InsurerDetails,
  inscongratulationspage: CommonConstants.Routes.Application.Congratulations,
  inspolicypage: CommonConstants.Routes.Application.Congratulations,
  hrevampmobileverification: CommonConstants.Routes.Verification.Home.concat('/', CommonConstants.Routes.Verification.VerifyMobile),
  emiotppage: CommonConstants.Routes.otp,
  inshurraypage: CommonConstants.Routes.Application.Congratulations,
  retrypaymentpage: CommonConstants.Routes.Application.PaymentFailed,
  multitabfailed: CommonConstants.Routes.MultitabFailed,
  resumequotelisting: CommonConstants.Routes.CustomerLogin,
  lifestyledetails: CommonConstants.Routes.QuestionnaireModule.MoreAboutYou,
  additionaladdressdetails: CommonConstants.Routes.QuestionnaireModule.MoreAboutYou,
  femalerelatedquestions: CommonConstants.Routes.QuestionnaireModule.MoreAboutYou,
  pastrelatedquestions: CommonConstants.Routes.QuestionnaireModule.MoreAboutYou,
  pendingpaymentpage: CommonConstants.Routes.Application.PendingPaymentPage,
  inprogress: CommonConstants.Routes.Application.PaymentStatus
};
@Injectable({
  providedIn: 'root'
})
export class RouteHandlerService {
  public Route: string = null;
  public NextTaskKey: string = null;
  public ExceptionKeyArr: any[];
  private taskKeyArray = TaskKeyArray;
  constructor(
    private _routeContextProvider: RouteContextProvider,
    private _formatter: Formatter,
    public _clevertapEventHandlerService: ClevertapEventHandlerService,
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    private _sessionHandlerService: SessionHandlerService
  ) { }
  public RouteToNextTask(nextTaskKey: string, exceptionKeysArr?: any, callback?: any, toReload?: boolean) {
    const varAuthType = window['varAuthType'];
    this._clevertapEventHandlerService.clevertapEvents("page_view", { page_url: document.URL, authType: varAuthType });
    this.Route = this.fetchRouteFromNextakKey(nextTaskKey);
    if (exceptionKeysArr && exceptionKeysArr.length > 0 && callback) {
      this.checkExceptionKeys(exceptionKeysArr, callback);
    } else if (callback) {
      callback(this.Route);
    } else if (this.Route) {
      this._routeContextProvider.NavigateToView([this.Route]);
      if (toReload) {
        if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
          window.location.pathname = this.Route;
        } else {
          const pathname = window.location.pathname;
          const convertedUrl = this.changePathname(pathname);
          window.location.pathname = convertedUrl;
        }
      }

    } else {
      console.error('ERROR:: Route not available.');
    }
  }
  private changePathname(pathUrl: string) {
    const resArray = pathUrl.split('/');
    const poppedItem = resArray.pop();
    let result;
    result = resArray.join('/').toString();
    let refactorUrl;
    let replaceResult;
    if (result.indexOf('/final') !== -1) {
      replaceResult = result.replace('/final', '');
      refactorUrl = replaceResult + '/' + this.Route;
    } else {
      refactorUrl = result + '/' + this.Route;
    }
    return refactorUrl;
  }
  private fetchRouteFromNextakKey(nextTaskKey: string): string {
    this.NextTaskKey = this._formatter.toSmallCase(nextTaskKey);
    return this.taskKeyArray[this.NextTaskKey] || '';
  }
  private checkExceptionKeys(exceptionKeysArr, callback: any) {
    let toRoute = false;
    this.ExceptionKeyArr = exceptionKeysArr;
    for (let key of this.ExceptionKeyArr) {
      key = this._formatter.toSmallCase(key);
      if (this.NextTaskKey === key) {
        toRoute = false;
        callback(this.Route);
        break;
      } else {
        toRoute = true;
      }
    }
    if (toRoute) {
      this._routeContextProvider.NavigateToView([this.Route]);
    }
  }
  public setQueryParams() {
    let paramObj = {};
    this.activatedRoute.queryParams.forEach((param) => {
      console.log('param values are ', param);
      paramObj = param;
      if (param && Object.keys(param).length > 0) {
        /*** Params for the Diff source journey */
        this.sharedService.setData(CommonConstants.QueryParamsKeys.journeySource,
          param[CommonConstants.QueryParamsKeys.journeySource] || null);
        this.sharedService.setData(CommonConstants.QueryParamsKeys.applicationId,
          param[CommonConstants.QueryParamsKeys.applicationId]);

        this.sharedService.setData(CommonConstants.QueryParamsKeys.productCode,
          param[CommonConstants.QueryParamsKeys.productCode]);
        this.sharedService.setData(CommonConstants.QueryParamsKeys.product,
          param[CommonConstants.QueryParamsKeys.product]);
        this.sharedService.setData(CommonConstants.QueryParamsKeys.appUtmSource,
          param[CommonConstants.QueryParamsKeys.appUtmSource]);
        const paramProductCode = param[CommonConstants.QueryParamsKeys.productCode];
        if (paramProductCode) {
          this._sessionHandlerService.SetSession(CommonConstants.QueryParamsKeys.productCode, param[CommonConstants.QueryParamsKeys.productCode]);
        }
      }
    });
    const src_90 = this.GetQueryParams('src_90');
    const src_60 = this.GetQueryParams('src_60');
    const src_30 = this.GetQueryParams('src_30');
    const pid = this.GetQueryParams('pid');
    const source = this.GetQueryParams('utm_source');
    const medium = this.GetQueryParams('utm_medium');
    const campaign = this.GetQueryParams('utm_campaign');
    const content = this.GetQueryParams('utm_content');
    const term = this.GetQueryParams('utm_term');
    const utmType = src_90 ? 'src_90' : src_60 ? 'src_60' : src_30 ? 'src_30' : pid ? 'pid' : 'utm';
    let utm = '';
    if ((source || medium || campaign || content || term) && utmType === 'utm') {
      utm = ['', source, medium, campaign, content, term].join(':');
    }
    this._sessionHandlerService.SetSession('UTM', src_90 || src_60 || src_30 || pid || utm);
    this._sessionHandlerService.SetSession('UtmType', utmType);
  }
  // Invoke via call method
  public GetQueryParams(key: string): string {
    let result;
    this.activatedRoute.queryParams.forEach((params) => {
      result = params[key] || CommonConstants.DEFAULT_EMPTY_STRING;
    });
    return result;
  }
  public UtmStamping() {
    let visitorID = null;
    setTimeout(() => {
      if (window['_satellite']) {
        const _satellite: any = Object.keys(window['_satellite']).length;
        if (_satellite && _satellite.length !== 0) {
          visitorID = window['_satellite']['getVisitorId']()['getMarketingCloudVisitorID']();
        }
      }
    }, 5000);
    let UTM: any = this._sessionHandlerService.GetSession('UTM');
    const UtmType = this._sessionHandlerService.GetSession('UtmType');
    UTM = UTM.split(':');
    if (UTM.length === 1) { UTM.length = []; }
    let defaultUtmSource = CommonConstants.utmSources.organic;
    const sourcing = {
      utmSource: UTM.length ? UTM[1] ? UTM[1] : defaultUtmSource : defaultUtmSource,
      utmMedium: UTM.length ? UTM[2] || '' : null, //(UtmType === 'pid' ? UTM[1] : UTM[2])
      utmCampaign: UTM.length ? UTM[3] || '' : null,
      utmContent: UTM.length ? UTM[4] || '' : null,
      utmTerm: UTM.length ? UTM[5] || '' : null,
      gclId: visitorID ? visitorID : null,
      recVersion: 1
    };
    return sourcing;
  }
}
